import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../core/http/api.service';
import { UtilsService } from '../../core/services/utils/utils.service';

@Component({
  selector: 'app-twitter-posts-dashboard',
  templateUrl: './twitter-posts-dashboard.component.html',
  styleUrls: ['./twitter-posts-dashboard.component.css'],
  standalone: false,
})
export class TwitterPostsDashboardComponent implements OnInit, OnDestroy {
  loading = true;
  run: any = null;
  selectedGoldenHandle: any = null;
  page = 1;
  readonly perPage = 20;
  private poll?: ReturnType<typeof setInterval>;

  constructor(private api: ApiService, private utils: UtilsService) {}

  ngOnInit(): void {
    this.loadRun();
    this.startPolling();
  }

  ngOnDestroy(): void { this.stopPolling(); }

  get isActive(): boolean {
    return ['queued', 'running'].includes(this.run?.status);
  }

  get progress(): number {
    const total = Number(this.run?.totalHandles || 0);
    return total ? Math.round((Number(this.run?.processedHandles || 0) / total) * 100) : 0;
  }

  get results(): any[] {
    return Array.isArray(this.run?.handleResults) ? this.run.handleResults : [];
  }

  get hasFailedHandles(): boolean {
    return this.results.some((result) => result.status === 'failed');
  }

  get completedHandles(): number {
    return this.results.filter((result) => result.status === 'completed').length;
  }

  get fetchingHandles(): number {
    return this.results.filter((result) => result.status === 'fetching').length;
  }

  get failedHandles(): number {
    return this.results.filter((result) => result.status === 'failed').length;
  }

  openGoldenHandle(result: any): void {
    this.selectedGoldenHandle = {
      id: result.goldenListMemberId,
      name: result.name,
      xHandle: result.handle,
    };
  }

  closeGoldenHandle(): void {
    this.selectedGoldenHandle = null;
  }

  pageChange(page: number): void {
    this.page = page;
  }

  loadRun(): void {
    this.api.getLatestTwitterGoldenListPostRun().subscribe(
      (res) => {
        this.run = res?.data || null;
        const lastPage = Math.max(1, Math.ceil(this.results.length / this.perPage));
        if (this.page > lastPage) this.page = lastPage;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.utils.resErr(err);
      },
    );
  }

  private startPolling(): void {
    if (!this.poll) this.poll = setInterval(() => this.loadRun(), 3000);
  }

  private stopPolling(): void {
    if (this.poll) clearInterval(this.poll);
    this.poll = undefined;
  }
}
